module.exports = __webpack_public_path__ + "static/benefit-1-9f81c2698cf2d66bd6729954b2ea55b9.svg";